(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('serica-card-gallery')) {
  customElements.define('serica-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const data = this.querySelector('[data-gallery-images]');
      const image = this.querySelector('img');
      if (!data || !image) return;
      const images = JSON.parse(data.textContent);
      let index = Math.max(0, images.findIndex(item => image.currentSrc.split('?')[0].endsWith(item.src.split('?')[0].split('/').pop())));
      const preview = image.cloneNode(false);
      preview.className = 'serica-hover-image';
      preview.removeAttribute('srcset');
      preview.removeAttribute('id');
      preview.alt = '';
      preview.setAttribute('aria-hidden', 'true');
      image.parentElement.append(preview);
      let hovering = false;
      let clicked = false;
      const preparePreview = () => {
        preview.src = images[(index + 1) % images.length].src;
      };
      const showPreview = () => {
        if (hovering && !clicked && preview.complete && preview.naturalWidth) this.setAttribute('data-hover-preview', '');
      };
      preview.addEventListener('load', showPreview);
      preparePreview();
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        hovering = true;
        clicked = false;
        preparePreview();
        showPreview();
      });
      this.addEventListener('pointerleave', () => {
        hovering = false;
        clicked = false;
        this.removeAttribute('data-hover-preview');
      });
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          clicked = true;
          this.removeAttribute('data-hover-preview');
          index = (index + Number(button.dataset.direction) + images.length) % images.length;
          image.removeAttribute('srcset');
          image.src = images[index].src;
          image.alt = images[index].alt;
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["serica-product-save"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('serica-product-save')) {
  customElements.define('serica-product-save', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.dispatchEvent(new CustomEvent('serica:saved-refresh', {bubbles:true})); });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
